import { AttentionIcon } from "components/Icons/AttentionIcon";
import { ExclamationMarkEllipse } from "components/Icons/ExclamationMarkEllipse";
import { XIcon } from "components/Icons/XIcon";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
    withStyles,
} from "material-ui";
import moment from "moment";
import React, { ReactElement } from "react";

export enum DialogType {
    Optional,
    Required,
}

interface IKycDialogProps {
    open: boolean;
    title: string;
    content: string[];
    type: DialogType;
    onConfirm?: () => void;
    onCancel?: () => void;
}

type KycDialogProps = IKycDialogProps;

class KycDialog extends React.Component<KycDialogProps> {
    constructor(props: KycDialogProps) {
        super(props);
        this.renderDialogActions = this.renderDialogActions.bind(this);
    }

    renderTopBar(): JSX.Element {
        return (
            <Grid container className={"topbar-container"}>
                <Grid item xs={2} className={"exclamation-mark-container"}>
                    <ExclamationMarkEllipse />
                </Grid>
                <Grid item xs={8} className={"title-container"}>
                    <h3>{this.props.title}</h3>
                </Grid>
                <Grid item xs={2} className={"exit-button-container"}>
                    {this.props.type === DialogType.Optional && (
                        <IconButton
                            component="div"
                            onClick={this.props.onCancel}
                        >
                            <XIcon />
                        </IconButton>
                    )}
                </Grid>
            </Grid>
        );
    }

    renderContentTopSection(): JSX.Element {
        return (
            <Grid container className={"content-top-container"}>
                <Grid item xs={6} className={"content-top"}>
                    Viesti 1/1
                </Grid>
                <Grid item xs={6} className={"date-container"}>
                    {moment().format("DD.MM.YYYY")}
                </Grid>
            </Grid>
        );
    }

    renderDialogActions(): JSX.Element | null {
        return (
            <Grid container>
                <Grid item xs={12}>
                    <Button
                        className={"hypo-primary"}
                        fullWidth={true}
                        variant="flat"
                        onClick={this.props.onConfirm}
                        style={{ minHeight: "54px" }}
                    >
                        Sulje ja siirry KYC-tietojen tarkastukseen
                    </Button>
                </Grid>
                {this.props.type === DialogType.Optional && (
                    <Grid item xs={12}>
                        <Button
                            className={"hypo-tertiary"}
                            fullWidth={true}
                            variant="flat"
                            onClick={this.props.onCancel}
                            style={{ minHeight: "54px" }}
                        >
                            <XIcon width={13} height={12} fill={"#646363"} />
                            {String.fromCharCode(160)}Sulje
                        </Button>
                    </Grid>
                )}
            </Grid>
        );
    }

    public render() {
        return (
            <Dialog
                maxWidth={"xs"}
                open={this.props.open}
                disableBackdropClick={true}
            >
                <Grid id={"kyc-dialog-topbar"} container>
                    {this.renderTopBar()}
                </Grid>
                <DialogContent id="kyc-dialog-content">
                    {this.renderContentTopSection()}
                    {this.props.content.map((text) => (
                        <DialogContentText>{text}</DialogContentText>
                    ))}
                </DialogContent>
                <DialogActions id="kyc-dialog-actions">
                    {this.renderDialogActions()}
                </DialogActions>
            </Dialog>
        );
    }
}

export default KycDialog;



// WEBPACK FOOTER //
// ./src/components/Dialog/KycDialog.tsx